import React, { useEffect, useState } from "react";
import "./pricing.css";
import InPlayer from "../backend/inplayer";
import CarouselContentLoader from "../loader/contentLoader";
import Global from "../../global";
import { SubStore } from "../store/subStore";
import { PlanStore } from "../store/planStore";
import { Link, useHistory } from "react-router-dom";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const Plans = (props) => {
  const [accessFees, setAccessFees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [subFlag, setSubFlag] = useState(false);
  const selectedPlan = SubStore.useState((s) => s.selectPrice);
  const paidplan = PlanStore.useState((s) => s.plan);
  let assetId =
    props.match.params.AssetId && props.match.params.AssetId !== "undefined"
      ? props.match.params.AssetId
      : Global.OFFERS[0].planid
      ? Global.OFFERS[0].planid
      : "";
  const queryParams = new URLSearchParams(window.location.search);
  const redirect = queryParams.get("redirect");
  const type = queryParams.get("type");

  let history = useHistory();
  useEffect(() => {
    async function fetchAccessFees() {
      await InPlayer.Asset.getAssetAccessFees(assetId)
        .then((res) => {
          setAccessFees(res.data);
          setLoading(false);
        })
        .catch((error) => {});
    }

    async function checkAccess() {
      await InPlayer.Asset.checkAccessForAsset(assetId).then((data) => {
        PlanStore.update((s) => {
          s.plan = data;
        });
      });
    }

    fetchAccessFees();

    if (paidplan === null) {
      checkAccess();
    } else {
      if (Global.OFFERS[0].planid === assetId || assetId === "undefined") {
        setSubFlag(true);
      } else {
        setSubFlag(false);
      }
    }
  }, [paidplan, assetId]);

  const handlePayment = (e) => {
    e.preventDefault();

    if (InPlayer.Account.isAuthenticated()) {
      if (selectedPlan) {
        let path = "/" + props.match.params.AppId + "/payment";
        if (type && redirect) {
          path =
            "/" +
            props.match.params.AppId +
            "/payment?type=" +
            type +
            "&redirect=" +
            redirect;
        } else {
          path = "/" + props.match.params.AppId + "/payment";
        }

        history.push(path);
      } else {
        toastr.info("Please Select a Plan to Continue", "No Plan Selected");
      }
    } else {
      let path = "/" + props.match.params.AppId + "/login";
      history.push(path);
    }
  };
  const handlePriceChange = (item) => {
    SubStore.update((s) => {
      s.selectPrice = item;
    });
  };

  if (!loading) {
    return (
      <div
        className="pricingPlan"
        style={{
          background: "url(/images/home/show-1.jpg) no-repeat scroll 0 0",
        }}
      >
        <div className="main-content">
          {/* Start Pricing Section */}
          <section className="pricing">
            <div className="container">
              <div className="row text-center intro">
                <div className="col-12">
                  <h2>
                    {paidplan === null ? "Select Your Plan" : "Your Plan"}
                  </h2>
                  {/* <p className="text-max-800">Choose the ideal plan for what you need. We work with affordable prices for all types of pocket.</p> */}
                </div>
                {/* Col End */}
              </div>
              {/* Row End */}
              <div className="row">
                {/* Standard Plan */}
                <div className="col-lg-12 mx-auto">
                  <div className="card mb-5 mb-lg-0 center">
                    <div className="card-body card-row">
                      <div className="row">
                        <div className="col-md-6">
                          <h6 className="card-price text-center card-plan">
                            Watch Ad-Free with Premium!
                          </h6>
                          <hr />
                          <ul className="fa-ul">
                            <li>Ad free experience</li>
                            <li>Streamit Special</li>
                            <li>American Tv Shows</li>
                            <li>Hollywood Movies</li>
                            <li>FHD (1080p) Video Quality</li>
                            <li>Ad Free Entertainment</li>
                          </ul>
                        </div>
                        <div className="col-md-6">
                          <ul className="fa-ul pricingul">
                            {!subFlag ? (
                              accessFees.length > 0 ? (
                                accessFees.map((item, index) => (
                                  <li className="border-box" key={index}>
                                    <label className="price-label">
                                      <div className="price-wrapper">
                                        <div className="price-index">
                                          <h5>{item.description}</h5>
                                          <input
                                            type="radio"
                                            name="favorite_plan"
                                            onChange={(e) => {
                                              handlePriceChange(item);
                                            }}
                                            checked={
                                              selectedPlan !== null &&
                                              selectedPlan.id === item.id
                                                ? true
                                                : false
                                            }
                                          />

                                          <h6>
                                            {item.amount + " " + item.currency}
                                          </h6>
                                        </div>
                                        <div className="price-descrption">
                                          <p
                                            className={
                                              item.trial_period
                                                ? "text-muted"
                                                : "none"
                                            }
                                          >
                                            {item.trial_period
                                              ? item.trial_period.quantity +
                                                " " +
                                                item.trial_period.period +
                                                " Trail Period"
                                              : ""}
                                          </p>
                                          <p
                                            className={
                                              item.access_type
                                                ? "text-muted"
                                                : "none"
                                            }
                                          >
                                            {item.access_type
                                              ? item.access_type.name ===
                                                "subscription"
                                                ? " Recurring payment per " +
                                                  item.access_type.period
                                                : item.access_type.name ===
                                                  "ppv"
                                                ? item.access_type.quantity +
                                                  " " +
                                                  item.access_type.period +
                                                  " access"
                                                : "One time Payment"
                                              : ""}
                                          </p>
                                        </div>
                                      </div>
                                    </label>
                                  </li>
                                ))
                              ) : (
                                <li
                                  className="border-box no-border"
                                  key={"not_prem_1"}
                                >
                                  <label className="price-label">
                                    <div className="price-wrapper">
                                      <div className="price-wrapper">
                                        <div className="price-index">
                                          <h5>{"Not Available"}</h5>
                                        </div>
                                        <div className="price-descrption border-margin">
                                          <p className="text-muted">
                                            {" "}
                                            Pricing Not Available.
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </label>
                                </li>
                              )
                            ) : (
                              <li
                                className="border-box no-border"
                                key={"not_prem_0"}
                              >
                                <label className="price-label">
                                  <div className="price-wrapper">
                                    <div className="price-wrapper text-center">
                                      <div className="price-header">
                                        <h5 className="home">
                                          {"Already Subscribed"}
                                        </h5>
                                      </div>
                                      <div className="price-descrption border-margin">
                                        <p className="text-muted">
                                          {" "}
                                          You have already purchased this
                                          premium asset
                                        </p>
                                      </div>
                                      <div className="home text-center">
                                        {" "}
                                        <Link
                                          className="btn btn-hover"
                                          to={
                                            "/" +
                                            props.match.params.AppId +
                                            "/home"
                                          }
                                        >
                                          Start Watching
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                </label>
                              </li>
                            )}
                          </ul>

                          <div className="text-center card-button">
                            {!subFlag ? (
                              <a
                                href="#!"
                                className="btn btn-block btn-hover text-uppercase"
                                onClick={handlePayment}
                              >
                                {selectedPlan !== null
                                  ? "Proceed to Pay " +
                                    selectedPlan.amount +
                                    " " +
                                    selectedPlan.currency
                                  : " Proceed To Payment"}
                              </a>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Card Body End */}
                  </div>
                  {/* Card End */}
                </div>
                {/* Col End */}
              </div>
              {/* Row End */}
            </div>
            {/* Container End */}
          </section>
          {/* Pricing Section End */}
        </div>
      </div>
    );
  } else {
    return <CarouselContentLoader></CarouselContentLoader>;
  }
};

export default Plans;
